import { PhxCalendarConfiguration } from '../config/calendar_configuration';
import { ICommand } from 'core-ts-types';
import { UnlockedTimeQuery } from '../query_models/unlocked_time_query';

export class CalendarController implements ng.IComponentController {
  ngModel: any;
  onSaveTime: Function;
  onDeleteTime: Function;
  onEditTime: Function;
  onTimesLoaded: Function;
  hourBegin: string;
  hourEnd: string;
  showListView: any;
  prefsModeActive: any;
  includeWeekends: string;
  microheaders: string;
  enums: any;

  constructor(
    private loadTimesCommand: ICommand,
    private resetTimesStoreCommand: ICommand,
    private getDayEnums: Function,
    public ngUnlockedTimeQuery: UnlockedTimeQuery,
    private ngPhxCalendarConfiguration: PhxCalendarConfiguration
  ) {}

  $onChanges(changes: any) {
    if (
      !_.isUndefined(changes.ngModel) &&
      !angular.equals(changes.ngModel.previousValue, changes.ngModel.currentValue)
    ) {
      this.resetTimesStoreCommand();
      this.loadTimesCommand(changes.ngModel.currentValue);
      this.onTimesLoaded();
    }
    if (changes.hourBegin && !angular.equals(changes.hourBegin.previousValue, changes.hourBegin.currentValue)) {
      this.ngPhxCalendarConfiguration.hourBegin = this.hourBegin;
    }
    if (changes.hourEnd && !angular.equals(changes.hourEnd.previousValue, changes.hourEnd.currentValue)) {
      this.ngPhxCalendarConfiguration.hourEnd = this.hourEnd;
    }
    if (changes.onSaveTime && !angular.equals(changes.onSaveTime.previousValue, changes.onSaveTime.currentValue)) {
      this.ngPhxCalendarConfiguration.save = this.onSaveTime;
    }
    if (
      changes.onDeleteTime &&
      !angular.equals(changes.onDeleteTime.previousValue, changes.onDeleteTime.currentValue)
    ) {
      this.ngPhxCalendarConfiguration.delete = this.onDeleteTime;
    }
    if (changes.onEditTime && !angular.equals(changes.onEditTime.previousValue, changes.onEditTime.currentValue)) {
      this.ngPhxCalendarConfiguration.edit = this.onEditTime;
    }
    if (
      changes.includeWeekends &&
      !angular.equals(changes.includeWeekends.previousValue, changes.includeWeekends.currentValue)
    ) {
      this.enums = this.getDayEnums(this.includeWeekends, this.microheaders);
    }
    if (
      changes.microheaders &&
      !angular.equals(changes.microheaders.previousValue, changes.microheaders.currentValue)
    ) {
      this.enums = this.getDayEnums(this.includeWeekends, this.microheaders);
    }
    if (
      changes.showListView &&
      !angular.equals(changes.showListView.previousValue, changes.showListView.currentValue)
    ) {
      this.showListView = _.isUndefined(this.showListView) ? false : this.showListView;
    }
  }

  $onInit() {
    // Q: Why was this called in old code? Calling this make two instances of each busy times.
    // this.loadTimesCommand(this.ngModel);
    this.ngPhxCalendarConfiguration.hourBegin = this.hourBegin;
    this.ngPhxCalendarConfiguration.hourEnd = this.hourEnd;
    this.ngPhxCalendarConfiguration.save = this.onSaveTime;
    this.ngPhxCalendarConfiguration.delete = this.onDeleteTime;
    this.ngPhxCalendarConfiguration.edit = this.onEditTime;
    this.enums = this.getDayEnums(this.includeWeekends, this.microheaders);
    this.showListView = _.isUndefined(this.showListView) ? false : this.showListView;
  }
}

angular
  .module('ui-ng-calendar')
  .controller('phxCalendarController', CalendarController)
  .constant('phxCalendarDelegateConfiguration', function () {
    return;
  })
  .component('phxCalendar', {
    bindings: {
      ngModel: '<',
      onSaveTime: '&',
      onDeleteTime: '&',
      onEditTime: '&',
      onTimesLoaded: '&',
      hourBegin: '@',
      hourEnd: '@',
      showListView: '<',
      prefsModeActive: '<',
      includeWeekends: '@',
      microheaders: '@',
      mode: '<'
    },
    templateUrl: 'ui-ng-calendar/src/component/calendar.html',
    controller: 'phxCalendarController'
  });



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar/src/component/calendar_component.ts